module.exports = __webpack_public_path__ + "static/img/y3_4.9674677.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/y3_4.jpg
// module id = Sg4P
// module chunks = 0